/**
 * Utility constanct conversion functions
 */

// Gender Related Mappers
export function genderMapper(gender) {
    switch (gender) {
        case 'MALE':
            return 'Erkek'
        case 'FEMALE':
            return 'Kadin';
        default:
            return '-'
    }
}

export function genderOptions() {
    return [
        { label: 'Erkek', value: 'MALE' },
        { label: 'Kadin', value: 'FEMALE' },
    ];
}

export function getGenderOption(gender) {
    switch (gender) {
        case 'MALE':
            return { label: 'Erkek', value: 'MALE' }
        case 'FEMALE':
            return { label: 'Kadin', value: 'FEMALE' }
        default:
            return { label: 'Bilinmiyor', value: 'UNKNOWN' }
    }
}

// Payment Realted Mappers
export function paymentTypeMapper(type) {
    switch (type) {
        case 'CC':
            return 'Kredi Karti'
        case 'CASH':
            return 'Nakit'
        default:
            return '-'
    }
}

export function paymentOptions() {
    return [
        {
            label: 'Kredi Karti',
            value: 'CC',
        },
        {
            label: 'Nakit',
            value: 'CASH',
        },
    ]
}

// Appointment Status Related Mappers
export function appointmentStatusMapper(status) {
    switch (status) {
        case 'PLANNED':
            return 'Planlandi'
        case 'CANCELLED':
            return 'Iptal Edildi';
        case 'COMPLETED':
            return 'Tamamlandi'
        default:
            return ''
    }
}

export function appointmentTypeMapper(type) {
    switch (type) {
        case 'INTRODUCTION':
            return 'Tanisma'
        case 'REGIME_SESSION':
            return 'Diyet Seansi'
        case 'REGIONAL_LOSS':
            return 'Bolgesel Zayiflama'
        default:
            return '';
    }
}